import axios from 'axios';
import { AppThunk } from '../../../stores';
import { setMessage } from '../ui';
import { setApp, setLoading } from '.';

export function getApp(): AppThunk {
  return async (dispatch, getState) => {
    dispatch(setLoading(true));
    try {
      const url = `${getState().basis.serverUrl}/app`;
      const res = await axios.get(url);

      if (res.status === 200) {
        dispatch(setApp(res.data.data));
      } else {
        dispatch(setMessage({
          intent: 'danger',
          message: `${res.status} ${res.statusText}. ${res.data.message}`,
        }));
      }
    } catch (err: any) {
      const message = axios.isAxiosError(err) ? err.message : 'An unexpected error occurred.';
      dispatch(setMessage({ intent: 'danger', message }));
    }
    dispatch(setLoading(false));
  };
}